import(/* webpackMode: "eager" */ "/opt/render/project/src/app/premium-courses/[slug]/page.jsx");
